// ハンバーガーメニューメニュー

document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector(".c-header-menu a"); // ハンバーガーボタン
  const hamburgerMenu = document.querySelector(".l-hamburger-nav"); // メニュー本体
  const backgroundOverlay = document.querySelector(".l-hamburger-background"); // 背景オーバーレイ
  const header = document.querySelector(".header"); // 固定ヘッダー
  const html = document.documentElement;
  const body = document.body;

  let isMenuOpen = false;
  let scrollY = 0;

  // スクロールロック
  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset;
    html.classList.add("is-locked");
    body.classList.add("is-locked");
    body.style.top = `-${scrollY}px`;
  }

  // スクロール解除
  function unlockScroll(restore = true) {
    html.classList.remove("is-locked");
    body.classList.remove("is-locked");
    body.style.top = "";

    if (restore) {
      window.scrollTo(0, scrollY);
    }
  }

  function openMenu() {
    if (isMenuOpen) return;
    isMenuOpen = true;

    lockScroll();

    hamburgerMenu.classList.add("is-show");
    backgroundOverlay.classList.add("is-show");
    menuButton.classList.add("is-show");
  }

  function closeMenu({ restoreScroll = true, afterClose } = {}) {
    if (!isMenuOpen) return;
    isMenuOpen = false;

    hamburgerMenu.classList.remove("is-show");
    backgroundOverlay.classList.remove("is-show");
    menuButton.classList.remove("is-show");

    // body の状態はすぐ戻す（setTimeoutやCLOSE_DELAYなし）
    unlockScroll(restoreScroll);

    // レイアウトが安定した次のフレームで実行
    if (typeof afterClose === "function") {
      requestAnimationFrame(afterClose);
    }
  }

  function toggleHamburgerMenu(e) {
    e.preventDefault();
    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  menuButton.addEventListener("click", toggleHamburgerMenu);

  // ハッシュ（ページ内リンク）にスクロール
  function scrollToHash(hash) {
    const target = document.querySelector(hash);
    if (!target) return;

    const headerH = header?.offsetHeight || 0;
    const y = target.getBoundingClientRect().top + window.scrollY - headerH;

    // スムース無しで即移動
    window.scrollTo({
      top: y,
      behavior: "auto",
    });

    // URLのハッシュだけ更新
    history.pushState(null, "", hash);
  }

  // メニュー内リンク（ページ内リンク + 外部リンク両方あり）
  document.querySelectorAll(".l-hamburger-nav a").forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href") || "";
      const currentPath = window.location.pathname;

      // 同じページ → メニュー閉じるだけ
      if (
        currentPath === href ||
        currentPath === href + "/" ||
        currentPath + "/" === href
      ) {
        e.preventDefault();
        closeMenu();
        return;
      }

      // 外部リンク（http/https） → メニュー閉じてブラウザに任せる
      if (href.startsWith("http://") || href.startsWith("https://")) {
        closeMenu();
        return;
      }

      // トップアンカー以外 → メニュー閉じてブラウザに任せる
      if (!href.startsWith("/#")) {
        closeMenu();
        return;
      }

      // トップページにいない → メニュー閉じてブラウザに任せる
      if (currentPath !== "/") {
        closeMenu();
        return;
      }

      // トップページにいて、トップアンカー → メニュー閉じてスクロール
      e.preventDefault();
      closeMenu({
        restoreScroll: false,
        afterClose: () => scrollToHash(href.slice(1)),
      });
    });
  });

  // 背景オーバーレイクリックで閉じる
  backgroundOverlay.addEventListener("click", () => {
    closeMenu();
  });
});

// ドロップダウンメニュー

document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll(".dropdown");
  const mql = window.matchMedia("(max-width: 960px)");

  dropdowns.forEach((dropdown) => {
    const btn = dropdown.querySelector(".dropdown-btn");
    const list = dropdown.querySelector(".dropdown-list");
    if (!btn || !list) return;

    const inOverflowParent = dropdown.closest(".product_list_box_wrap");
    const isBuyButton = btn.classList.contains("btn-buy");

    if (inOverflowParent && isBuyButton && typeof tippy !== "undefined") {
      const tippyInstance = tippy(btn, {
        content: list,
        interactive: true,
        trigger: "click",
        placement: "bottom-start",
        appendTo: () => (mql.matches ? document.body : dropdown),
        theme: "dropdown-buy",
        offset: [0, 4],
        maxWidth: "none",
        onShow(instance) {
          dropdown.classList.add("active");
          const btnWidth = btn.offsetWidth;
          instance.popper.style.width = btnWidth + "px";
        },
        onHide() {
          dropdown.classList.remove("active");
        },
      });

      const updateAppendTo = () => {
        tippyInstance.setProps({
          appendTo: () => (mql.matches ? document.body : dropdown),
        });
      };

      mql.addEventListener("change", updateAppendTo);
    } else {
      btn.addEventListener("click", (e) => {
        e.stopPropagation(); // 他のクリックイベントを止める
        dropdown.classList.toggle("active");
      });
    }
  });

  document.addEventListener("click", () => {
    document.querySelectorAll(".dropdown.active").forEach((dropdown) => {
      const btn = dropdown.querySelector(".dropdown-btn");
      if (btn && !btn._tippy) {
        dropdown.classList.remove("active");
      }
    });
  });
});

// サブメニュー
const items = document.querySelectorAll('.dropdown-list > li');

items.forEach(item => {
  const submenu = item.querySelector('.submenu-list');
  if (!submenu) return;

  item.addEventListener('mouseenter', () => {
    submenu.classList.add('is-show');
  });

  item.addEventListener('mouseleave', () => {
    submenu.classList.remove('is-show');
  });
});

// FAQアコーディオン 11/28修正版

document.addEventListener("DOMContentLoaded", () => {
  const questions = document.querySelectorAll(".question");

  function closeAnswer(answer) {
    // 既存のtransitionendリスナーがあれば削除（開きかけで閉じた場合の対策）
    if (answer._transitionHandler) {
      answer.removeEventListener("transitionend", answer._transitionHandler);
      answer._transitionHandler = null;
    }

    answer.style.height = `${answer.scrollHeight}px`;
    requestAnimationFrame(() => {
      answer.style.height = "0";
      answer.classList.remove("is-open");
    });
  }

  function openAnswer(answer) {
    // 念のため既存のリスナーを削除
    if (answer._transitionHandler) {
      answer.removeEventListener("transitionend", answer._transitionHandler);
      answer._transitionHandler = null;
    }

    answer.style.height = "0";
    answer.classList.add("is-open");
    requestAnimationFrame(() => {
      answer.style.height = `${answer.scrollHeight}px`;
    });

    const onEnd = (e) => {
      if (e.propertyName === "height") {
        answer.style.height = "auto";
        answer.removeEventListener("transitionend", onEnd);
        answer._transitionHandler = null;
      }
    };
    // リスナーを保存して後で削除できるようにする
    answer._transitionHandler = onEnd;
    answer.addEventListener("transitionend", onEnd);
  }

  questions.forEach((q) => {
    q.addEventListener("click", function () {
      const currentAnswer = this.nextElementSibling;
      const isOpen = currentAnswer.classList.contains("is-open");

      document.querySelectorAll(".answer.is-open").forEach((a) => {
        if (a !== currentAnswer) closeAnswer(a);
      });
      document.querySelectorAll(".question.active").forEach((qq) => {
        if (qq !== this) qq.classList.remove("active");
      });

      if (isOpen) {
        closeAnswer(currentAnswer);
        this.classList.remove("active");
      } else {
        openAnswer(currentAnswer);
        this.classList.add("active");
      }
    });
  });
});

// インスタグラム埋め込み用（仮）

// fetch(
//   `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink&access_token=YOUR_ACCESS_TOKEN`
// )
//   .then((res) => res.json())
//   .then((data) => {
//     const container = document.getElementById("instaFeedContainer");
//     data.data.forEach((item) => {
//       const slide = document.createElement("div");
//       slide.className = "swiper-slide";
//       slide.innerHTML = `
//         <a href="${item.permalink}" target="_blank">
//           <img src="${item.media_url}" alt="">
//         </a>`;
//       container.appendChild(slide);
//     });
//   });

// ======================
// インスタグラム Slider（複数＆逆方向対応）
// ======================
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Swiper === "undefined") return;

  const swiperEls = document.querySelectorAll(".insta-swiper");
  if (!swiperEls.length) return;

  swiperEls.forEach((swiperEl) => {
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    const originalSlides = Array.from(
      wrapper.querySelectorAll(".swiper-slide"),
    );
    if (!originalSlides.length) return;

    // 🔁 スライドが少ないときに複製して増やす（各スライダーごとに）
    while (wrapper.children.length < 8) {
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add("is-clone");
        wrapper.appendChild(clone);
      });
    }

    // このスライダーが逆方向かどうか
    const isReverse = swiperEl.classList.contains("insta-swiper--reverse");

    // Swiper 初期化
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 60,

      // 永遠に流れる系
      speed: 8000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: isReverse, // ←ここで方向切り替え！
      },

      freeMode: true,
      freeModeMomentum: false,
      allowTouchMove: true,

      breakpoints: {
        960: {
          spaceBetween: 60,
        },
        0: {
          spaceBetween: 16,
        },
      },
    });
  });
});

/// 1121追加
// 背景ブラー（安全版）
document.addEventListener("DOMContentLoaded", () => {
  const hero = document.querySelector("#hero");
  const bg = document.querySelector(".bg");

  // hero or bg が無いページ / 古い環境では何もしない
  if (!hero || !bg || !("IntersectionObserver" in window)) return;

  const io = new IntersectionObserver(
    ([entry]) => {
      // hero がビューポート外になったら blur
      bg.classList.toggle("is-blur", entry.intersectionRatio <= 0);
    },
    { root: null, threshold: 0 },
  );

  io.observe(hero);

  // ページ遷移時にクリーンアップ（SPA/戻る対策）
  window.addEventListener("pagehide", () => io.disconnect(), { once: true });
});

// 1204追加
// productスクロールバー
(() => {
  const wrap = document.querySelector(".product_list_box_wrap");
  const bar = document.querySelector(".custom-scrollbar__thumb");
  const barTrack = document.querySelector(".custom-scrollbar");

  if (!wrap || !bar || !barTrack) return;

  const updateBar = () => {
    const scrollWidth = wrap.scrollWidth;
    const clientWidth = wrap.clientWidth;
    const scrollLeft = wrap.scrollLeft;
    const trackWidth = barTrack.clientWidth;

    // スクロール不要なら非表示
    if (scrollWidth <= clientWidth) {
      bar.style.width = "0px";
      bar.style.transform = "translateX(0)";
      return;
    }

    // つまみの実際の幅(px)
    const thumbWidthPx = (clientWidth / scrollWidth) * trackWidth;
    bar.style.width = `${thumbWidthPx}px`;

    // スクロールの進行度（0〜1にクランプ）
    const maxScroll = scrollWidth - clientWidth;
    let ratio = maxScroll === 0 ? 0 : scrollLeft / maxScroll;
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;

    // つまみの左位置(px)
    const maxThumbX = trackWidth - thumbWidthPx;
    const thumbX = maxThumbX * ratio;
    bar.style.transform = `translateX(${thumbX}px)`;
  };

  wrap.addEventListener("scroll", updateBar);
  window.addEventListener("resize", updateBar);
  updateBar();
})();

// ======================
// Hero KV Swiper
// ======================
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Swiper === "undefined") return;

  const kvSwiper = document.querySelector(".kv_swiper");
  if (!kvSwiper) return;

  const totalSlides = kvSwiper.querySelectorAll(".swiper-slide").length;
  const bulletCount = totalSlides / 2;

  const waitForAdditionalImages = () => {
    console.log("[KV Swiper] waitForAdditionalImages called");
    const additionalSlides = kvSwiper.querySelectorAll(
      ".swiper-slide--additional",
    );
    console.log(
      "[KV Swiper] Additional slides count:",
      additionalSlides.length,
    );

    const imagePromises = Array.from(additionalSlides).map((slide, index) => {
      const img = slide.querySelector(".img-sp");
      if (!img) {
        console.log(`[KV Swiper] Slide ${index}: No img-sp found`);
        return Promise.resolve();
      }

      if (img.complete && img.naturalHeight > 0) {
        console.log(
          `[KV Swiper] Slide ${index}: Image already loaded (${img.naturalWidth}x${img.naturalHeight})`,
        );
        return Promise.resolve();
      }

      console.log(`[KV Swiper] Slide ${index}: Waiting for image load...`);
      return new Promise((resolve) => {
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
      });
    });

    return Promise.all(imagePromises);
  };

  const setHeightOnce = () => {
    console.log("[KV Swiper] setHeightOnce called");
    console.log("[KV Swiper] window.innerWidth:", window.innerWidth);
    console.log("[KV Swiper] window.innerHeight:", window.innerHeight);

    const kvArea = document.querySelector(".kv_area.swiper-enabled");
    const swiperWrapper = kvSwiper.querySelector(".swiper-wrapper");
    const allSlides = kvSwiper.querySelectorAll(".swiper-slide");
    const pagination = kvSwiper.querySelector(".swiper-pagination");

    if (!kvArea || !swiperWrapper || allSlides.length === 0) {
      console.log("[KV Swiper] Missing elements, aborting");
      console.log("[KV Swiper] kvArea:", kvArea);
      console.log("[KV Swiper] swiperWrapper:", swiperWrapper);
      console.log("[KV Swiper] allSlides.length:", allSlides.length);
      return;
    }

    let maxAdditionalHeight = 0;
    const KV_CONTAINER_PADDING_TOP = 60; // CSS の padding-top と同期

    allSlides.forEach((slide, index) => {
      if (slide.classList.contains("swiper-slide--additional")) {
        const img = slide.querySelector(".img-sp");
        const container = slide.querySelector(".kv_container");

        let actualHeight = 0;

        if (img && container) {
          const slideLink = slide.querySelector(".slide-link");
          const targetElement = slideLink || container;
          const targetRect = targetElement.getBoundingClientRect();
          const containerWidth = targetRect.width;

          if (containerWidth <= 0) {
            console.warn(
              `[KV Swiper] Additional slide ${index}: Width is invalid (${containerWidth}px), using fallback`,
            );
            actualHeight = container.offsetHeight;
          } else {
            const imageAspectRatio = img.naturalHeight / img.naturalWidth;
            const calculatedImageHeight = containerWidth * imageAspectRatio;

            actualHeight = calculatedImageHeight + KV_CONTAINER_PADDING_TOP;

            console.log(
              `[KV Swiper] Additional slide ${index}:`,
              `\n  - Using: ${slideLink ? "slide-link" : "container"} for width`,
              `\n  - Width: ${containerWidth.toFixed(2)}px`,
              `\n  - Image natural size: ${img.naturalWidth} × ${img.naturalHeight}`,
              `\n  - Image aspect ratio: ${imageAspectRatio.toFixed(4)}`,
              `\n  - Calculated image height: ${calculatedImageHeight.toFixed(2)}px`,
              `\n  - Padding top: ${KV_CONTAINER_PADDING_TOP}px`,
              `\n  - Total height: ${actualHeight.toFixed(2)}px`,
            );
          }
        } else if (container) {
          actualHeight = container.offsetHeight;
          console.log(
            `[KV Swiper] Additional slide ${index} container height (no img):`,
            actualHeight,
          );
        }

        if (actualHeight > maxAdditionalHeight) {
          maxAdditionalHeight = actualHeight;
        }
      }
    });

    if (maxAdditionalHeight === 0) {
      console.log("[KV Swiper] No additional slides found, aborting");
      return;
    }

    // ページネーション分の高さを追加
    const paginationHeight = pagination ? pagination.offsetHeight : 0;
    const paginationMargin = 30;
    const totalHeight =
      maxAdditionalHeight + paginationHeight + paginationMargin;

    console.log("[KV Swiper] Height calculation:", {
      maxAdditionalHeight: maxAdditionalHeight,
      paginationHeight: paginationHeight,
      paginationMargin: paginationMargin,
      totalHeight: totalHeight,
    });

    allSlides.forEach((slide) => {
      slide.style.height = maxAdditionalHeight + "px";
      slide.style.minHeight = maxAdditionalHeight + "px";
    });

    swiperWrapper.style.height = maxAdditionalHeight + "px";
    swiperWrapper.style.minHeight = maxAdditionalHeight + "px";
    swiperWrapper.style.maxHeight = maxAdditionalHeight + "px";

    console.log(
      "[KV Swiper] Heights applied successfully (parent elements auto-follow)",
    );
  };

  const swiperInstance = new Swiper(kvSwiper, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        if (index < bulletCount) {
          return (
            '<span class="' +
            className +
            '" data-bullet-index="' +
            index +
            '"></span>'
          );
        }
        return "";
      },
    },
    on: {
      init: function () {
        if (window.innerWidth <= 960) {
          let heightSet = false;

          window.addEventListener(
            "loadingComplete",
            () => {
              if (!heightSet) {
                heightSet = true;

                waitForAdditionalImages().then(() => {
                  setHeightOnce();
                });
              }
            },
            { once: true },
          );

          setTimeout(() => {
            if (!heightSet) {
              heightSet = true;

              waitForAdditionalImages().then(() => {
                setHeightOnce();
              });
            }
          }, 5000);
        } else {
          console.log("[KV Swiper] Condition NOT met (width > 960), skipping");
        }
      },
      slideChange: function () {
        const realIndex = this.realIndex % bulletCount;
        const bullets = document.querySelectorAll(
          ".kv_swiper .swiper-pagination-bullet",
        );
        bullets.forEach((bullet, index) => {
          if (index === realIndex) {
            bullet.classList.add("swiper-pagination-bullet-active");
          } else {
            bullet.classList.remove("swiper-pagination-bullet-active");
          }
        });
      },
    },
  });

  let resizeTimer = null;
  const handleResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth <= 960) {
        waitForAdditionalImages().then(() => {
          setTimeout(() => {
            setHeightOnce();
          }, 50);
        });
      } else {
        console.log("[KV Swiper] PC size, clearing mobile styles");

        const kvArea = document.querySelector(".kv_area.swiper-enabled");
        if (kvArea) kvArea.style.minHeight = "";
        if (kvSwiper) kvSwiper.style.minHeight = "";

        const swiperWrapper = kvSwiper.querySelector(".swiper-wrapper");
        if (swiperWrapper) {
          swiperWrapper.style.height = "";
          swiperWrapper.style.minHeight = "";
          swiperWrapper.style.maxHeight = "";
        }

        const allSlides = kvSwiper.querySelectorAll(".swiper-slide");
        allSlides.forEach((slide) => {
          slide.style.height = "";
          slide.style.minHeight = "";
        });
      }
    }, 150);
  };

  window.addEventListener("resize", handleResize);
});
